import settings from '../../package.json';

export const versionConfig = {
  gitSHA1: process.env.REACT_APP_GIT_SHA,
  version: settings.version,
};
